export const BUTTON_CLASSES = {
    primary: 'primary-btn border-0 ',
    'primary-auto': 'primary-btn primary-btn-auto border-0 ',
    'primary-auto-height32': 'primary-btn primary-btn-auto border-0 height-32',
    'primary-sm': 'primary-btn primary-btn-sm border-0 ',
    'primary-md': 'primary-btn primary-btn-md border-0 ',
    'primary-lg': 'primary-btn border-0 primary-btn-lg',
    'primary-popup': 'primary-btn border-0 rounded-0',
    secondary: 'secondary-btn border-0 ',
    'secondary-sm': 'secondary-btn secondary-btn-sm border-0 ',
    'secondary-md': 'secondary-btn secondary-btn-md border-0 ',
    'secondary-auto': 'hollow-btn-blue hollow-btn-blue-auto',
    'hollow-secondary': 'hollow-secondary font-medium secondary-auto',
    'secondary-auto-height32': 'secondary-btn border-0 secondary-auto height-32',
    'hollow-white': 'hollow-btn-white ',
    'hollow-white-xs': 'hollow-white-xs',
    'hollow-white-xs-radius20': 'hollow-white hollow-btn-gray-auto',
    'hollow-white-sm': 'hollow-btn-white hollow-btn-white-sm',
    'hollow-white-md': 'hollow-btn-white hollow-btn-white-md',
    'hollow-gray': 'hollow-btn-gray',
    'hollow-gray-auto': 'hollow-btn-gray hollow-btn-gray-auto',
    'hollow-white-auto': 'hollow-btn-white hollow-btn-white-auto',
    'hollow-gray-sm': 'hollow-btn-gray hollow-btn-gray-sm',
    'hollow-red-sm': 'hollow-btn-gray hollow-btn-gray-sm hollow-btn-red',
    'hollow-red-md': 'hollow-btn-gray hollow-btn-red-md hollow-btn-red',
    'hollow-red-auto-hight28': 'hollow-btn-gray hollow-btn-red-auto hollow-btn-red height-28',
    'hollow-dark': 'hollow-btn-dark hollow-btn-dark-sm',
    'file-upload': 'secondary-btn border-0 file-upload',
    'hollow-gray-radius20': 'hollow-btn-gray radius20',
    'hollow-gray-auto-height28': 'hollow-btn-gray hollow-btn-gray-auto  height-28',
    'hollow-gray-auto-height32': 'hollow-btn-gray hollow-btn-gray-auto  height-32',
    'hollow-gray-auto-radius20-height24': 'hollow-btn-gray hollow-btn-gray-auto  radius20 height-24',
    'hollow-gray-radius20-xs': 'hollow-btn-gray radius20 hollow-gray-radius20-xs',
    'neutral-popup': 'neutral-popup border-0 rounded-0',
    'btn-link': 'btn btn-link',
    neutral: 'primary-btn neutral-btn border-0 ',
    'neutral-disabled': 'primary-btn neutral-btn btn-disabled border-0 ',
    'neutral-disabledRad20Ht20': 'primary-btn neutral-btn border-0 hollow-btn-gray-auto btn-disabled radius20 height-24',
    'neutral-disabled-sm': 'primary-btn neutral-btn neutral-btn-sm btn-disabled border-0 ',
    'hollow-blue-sm': 'hollow-btn-blue hollow-btn-blue-sm',
};

export const getButtonClasses = (type) => BUTTON_CLASSES[type] ?? 'primary';
